import React from "react"
import { connect } from "react-redux"
import { useStaticQuery, Link, graphql } from "gatsby"
import { Flipper, Flipped } from 'react-flip-toolkit';
import { updateTag } from "../state/app"
import Layout from './layout'

const PortfolioLayout = ({ tag, dispatch, children }) => {

    const data = useStaticQuery(graphql`
  query {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, filter: {frontmatter: {type: {eq: "portfolio"}}}) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            title
            excerpt
            tags
            thumb {
                publicURL
              }
          }
          fields {
            slug
          }
        }
      }
    }

    tags: allMarkdownRemark {
      group(field: frontmatter___tags) {
        tag: fieldValue
      }
    }
  }`);

  const tags = data.tags.group;
  const portfolio = data.allMarkdownRemark.edges;

return <Layout>
              <div className="portfolio-container container" id="portfolio">
                <h1>Portfolio
                  <select className="select" onChange={(e) => dispatch(updateTag(e.target.value))} onBlur={(e) => dispatch(updateTag(e.target.value))} value={tag}>
                    <option value="">Show me everything</option>
                    {
                      tags.map((tag, i) => (
                        <option key={i} value={tag.tag}>{ tag.tag}</option>
                      ))
                    }
                  </select>
                </h1>

                <Flipper flipKey={tag} className="portfolio">

                  {portfolio.filter(({node}) => node.frontmatter.tags.includes(tag) || tag === '').map(({ node }) => (

                    <Flipped key={node.id} flipId={node.id}>

                      <div className="portfolio__item">

                        <Link to={'/portfolio'+node.fields.slug} state={{ isModal: true, keepScroll: true }}><img src={node.frontmatter.thumb.publicURL} alt="" loading="lazy" /></Link>
                        <h2><Link to={'/portfolio'+node.fields.slug} state={{ isModal: true, keepScroll: true }}>{node.frontmatter.title}</Link></h2>
                        <ul className="portfolio__item__tags">
                            { node.frontmatter.tags.map((tag, i) => (
                              <li key={i}>{tag}</li>
                            )) }
                        </ul>
                        <div><p>{node.frontmatter.excerpt}</p></div>

                      </div>
                      
                    </Flipped>

                  ))}

                  </Flipper>

                  {children}

            </div>
       </Layout>

}

export default connect(state => ({
  tag: state.app.tag
}), null)(PortfolioLayout)